import React from 'react'
import { PresentationContext, PresentationStateContext } from './context'

const withPresentation = Component => props => (
  <PresentationContext.Consumer>
    {presentation => (
      <PresentationStateContext.Consumer>
        {presentationState => (
          <Component
            {...props}
            presentation={presentation}
            presentationState={presentationState}
          />
        )}
      </PresentationStateContext.Consumer>
    )}
  </PresentationContext.Consumer>
)

export default withPresentation
